<template>
  <v-dialog v-model="show" persistent max-width="400px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>Nivel del incendio</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form v-model="valid">
          <v-container fluid>
            <!-- Aviso -->
            <v-row>
              <v-col sm="10">
                <v-select
                  :items="tiposIncendioNivel" disabled item-text="INCENDIO_NIVEL"
                  v-model="dataModified.TIPO_INCENDIO_NIVEL.INCENDIO_NIVEL" label="Nivel del incendio" outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="10">
                <vx-date-text-edit
                  v-model="dataModified.FECHA_INICIO" :min="fechaInicioMin"
                  label="Fecha de inicio" not-future outlined required
                  @focus="setCurrentDate(0)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="10">
                <vx-date-text-edit
                  v-model="dataModified.FECHA_FIN" :min="fechaFinMin" :max="fechaFinMax"
                  label="Fecha de fin" not-future outlined
                  @focus="setCurrentDate(1)"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form> <!-- Llegada -->
      </v-card-text>

      <v-card-actions>
        <v-btn text color="red" @click="close">Cancelar</v-btn>
        <v-btn text color="green" :disabled="acceptDisable" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapGetters } from 'vuex'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'
export default {
  props: {
    show: Boolean,
    idIncendio: String,
    dataNivel: Object
  },

  data: () => ({
    dataModified: null,
    valid: true,
    nivelesPosibles: ['Nivel 1', 'Nivel 2'],
    estadoIncendio: null

  }),

  computed: {
    incendio () {
      return this.$store.getters['incendio/getIncendioByID'](this.idIncendio)
    },
    ...mapGetters('incendio', [
      'tiposIncendioNivel'
    ]),
    fechaFinMax () {
      let fechaMin = null
      if (this.incendio && this.dataModified && this.dataNivel) {
        if (this.dataModified.index !== 0) {
          fechaMin = DateService.toDayjs(this.incendio.NIVELES[this.dataNivel.index - 1].FECHA_INICIO, FMT.date).format(FMT.date)
        }
      }
      return fechaMin
    },
    fechaInicioMax () {
      let fechaMin = null
      if (this.incendio && this.dataModified && this.dataNivel) {
        if (this.dataModified.index !== 0) {
          fechaMin = this.incendio.NIVELES[this.dataNivel.index - 1].FECHA_INICIO
        }
      }
      return fechaMin
    },
    fechaInicioMin () {
      let fechaMin = null

      if (this.incendio && this.dataNivel) {
        if (this.incendio.NIVELES.length === 0 || this.incendio.NIVELES.length === this.dataModified.index + 1) {
          fechaMin = DateService.toDayjs(this.incendio.ESTADOS[this.incendio.ESTADOS.length - 1].FECHA, FMT.date).format(FMT.date)
        } else {
          fechaMin = DateService.toDayjs(this.incendio.NIVELES[this.dataNivel.index + 1].FECHA_FIN, FMT.date).format(FMT.date)
        }
      }

      return fechaMin
    },
    fechaFinMin () {
      let fechaMin = null
      let fechaInicio = null

      if (this.incendio && this.dataModified && this.dataNivel) {
        fechaInicio = DateService.toDayjs(this.dataModified.FECHA_INICIO, FMT.date)
        fechaMin = fechaInicio.add(1, DayjsUnit.Minute).format(FMT.date)
      }
      return fechaMin
    },

    acceptDisable () {
      return (!this.valid)
    }

  },

  watch: {
    show () {
      if (this.show && this.dataNivel) {
        this.dataModified = this.dataNivel
        this.dataModified.FECHA_INICIO = DateService.toDayjs(this.dataNivel.FECHA_INICIO, FMT.date).format(FMT.date)
        this.dataModified.FECHA_FIN = this.dataNivel.FECHA_FIN ? DateService.toDayjs(this.dataNivel.FECHA_FIN, FMT.date).format(FMT.date) : ''
      }
    }
  },

  methods: {

    close () {
      this.$emit('close')
    },

    setCurrentDate (pos) {
      const currentDate = DateService.getCurrentDayJs().format(FMT.date)
      if (pos === 0 && !this.dataModified.FECHA_INICIO) {
        this.dataModified.FECHA_INICIO = currentDate
      } else if (pos === 1 && !this.dataModified.FECHA_FIN) {
        this.dataModified.FECHA_FIN = currentDate
      }
    },

    aceptar () {
      let nivelIncendio = this.incendio?.NIVELES?.find(x => x.ID_INCENDIO_NIVEL === this.dataModified.ID_INCENDIO_NIVEL)

      if (nivelIncendio) {
        let data = {
          ID_INCENDIO_NIVEL: this.dataModified.ID_INCENDIO_NIVEL,
          dataEstado: {
            ID_INCENDIO: this.idIncendio,
            ID_TIPO_INCENDIO_NIVEL: nivelIncendio.ID_TIPO_INCENDIO_NIVEL,

            FECHA_INICIO: DateService.toDayjs(this.dataModified.FECHA_INICIO, FMT.date).toISOString(),
            FECHA_FIN: this.dataModified.FECHA_FIN ? DateService.toDayjs(this.dataModified.FECHA_FIN, FMT.date).toISOString() : null
          }

        }
        this.$store.dispatch('incendio/editNivelIncendio', data)
        this.$emit('redrawIncendio')
        this.$emit('close')
      }
    }

  },
  mounted () {
    this.dataModified = {
      FECHA_INICIO: null,
      FECHA_FIN: null,
      ID_INCENDIO: null,
      ID_INCENDIO_NIVEL: null,
      ID_TIPO_INCENDIO_NIVEL: null,
      TIPO_INCENDIO_NIVEL: {
        INCENDIO_NIVEL: null
      },
      index: null
    }
  },
  created () {
    this.dataModified = {
      FECHA_INICIO: null,
      FECHA_FIN: null,
      ID_INCENDIO: null,
      ID_INCENDIO_NIVEL: null,
      ID_TIPO_INCENDIO_NIVEL: null,
      TIPO_INCENDIO_NIVEL: {
        INCENDIO_NIVEL: null
      },
      index: null
    }
  }
}
</script>

<style scoped>

</style>
